import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
let recruitTitle = '在线申请'
let url = window.location.href
if (url.indexOf('join/index') !== -1) {
    const query = url.split('?')
    recruitTitle = query && query.length > 0 && query[1] === 'schoolRecruitment=1' ? '毕业生招聘' : '在线申请'

}
export default new Router({
    mode: 'hash',
    base: '/',
    routes: [{
            path: '/',
            component: () => import('../components/view/Home.vue'),
            meta: {
                title: '恒宝官网'
            },
            children: [{
                    path: '/',
                    component: () => import('../components/view/Index.vue'),
                    meta: {
                        title: '恒宝股份'
                    }
                },
                {
                    path: '/about/index',
                    component: () => import('../components/view/about/Index.vue'),
                    meta: {
                        title: '公司简介'
                    }
                },
                {
                    path: '/about/history',
                    component: () => import('../components/view/about/History.vue'),
                    meta: {
                        title: '发展历程'
                    }
                },
                {
                    path: '/join/civilization',
                    component: () => import('../components/view/join/Civilization.vue'),
                    meta: {
                        title: '恒宝文化'
                    }
                },
                {
                    path: '/about/honor',
                    component: () => import('../components/view/about/Honor.vue'),
                    meta: {
                        title: '荣誉资质'
                    }
                },
                {
                    path: '/about/news',
                    component: () => import('../components/view/about/News.vue'),
                    meta: {
                        title: '恒宝动态'
                    }
                },



                {
                    path: '/news/list',
                    component: () => import('../components/view/news/List.vue'),
                    meta: {
                        title: '新闻列表'
                    }
                },

                {
                    path: '/news/media',
                    component: () => import('../components/view/news/Media.vue'),
                    meta: {
                        title: '媒体联络'
                    }
                },

                {
                    path: '/news/view1',
                    component: () => import('../components/view/news/View1.vue'),
                    meta: {
                        title: '恒宝股份与广发银行合作推出蓝牙Key盾'
                    }
                },
                {
                    path: '/news/view2',
                    component: () => import('../components/view/news/View2.vue'),
                    meta: {
                        title: '恒宝股份荣获江苏镇江2019年度科技创新“梦溪奖”'
                    }
                },
                {
                    path: '/news/view3',
                    component: () => import('../components/view/news/View3.vue'),
                    meta: {
                        title: '恒宝股份顺利通过GSMA SAS SM eSIM安全管理平台认证'
                    }
                },
                {
                    path: '/news/view4',
                    component: () => import('../components/view/news/View4.vue'),
                    meta: {
                        title: '恒宝股份中标中国邮政储蓄银行2020-2022年银行卡制卡及个人化外包服务采购项目'
                    }
                },

                {
                    path: '/news/view5',
                    component: () => import('../components/view/news/View5.vue'),
                    meta: {
                        title: '恒宝股份受邀出席缅甸银行研讨会'
                    }
                },
                {
                    path: '/news/view6',
                    component: () => import('../components/view/news/View6.vue'),
                    meta: {
                        title: '恒宝股份举办肯尼亚金融支付解决方案交流会'
                    }
                },

                {
                    path: '/news/view7',
                    component: () => import('../components/view/news/View7.vue'),
                    meta: {
                        title: '恒宝股份指纹识别卡亮相数字中国建设峰会'
                    }
                },
                {
                    path: '/news/view8',
                    component: () => import('../components/view/news/View8.vue'),
                    meta: {
                        title: '董事长钱京荣获丹阳市五一劳动奖章'
                    }
                },
                {
                    path: '/news/view9',
                    component: () => import('../components/view/news/View9.vue'),
                    meta: {
                        title: '恒宝股份荣获国家金卡工程金蚂蚁奖'
                    }
                },
                {
                    path: '/news/view10',
                    component: () => import('../components/view/news/View10.vue'),
                    meta: {
                        title: '恒宝股份召开2018年会，展望2023公司愿景'
                    }
                },
                {
                    path: '/news/view11',
                    component: () => import('../components/view/news/View11.vue'),
                    meta: {
                        title: '恒宝股份“物联网eSIM安全方案”入选工信部《民参军技术与产品推荐目录（2018年度）》'
                    }
                },
                {
                    path: '/news/view12',
                    component: () => import('../components/view/news/View12.vue'),
                    meta: {
                        title: '2019年度温室气体盘查报告'
                    }
                },
                {
                    path: '/news/view0',
                    component: () => import('../components/view/news/View0.vue'),
                    meta: {
                        title: '热烈祝贺恒宝股份通过美国运通资质认证'
                    }
                },
                {
                    path: '/news/view13',
                    component: () => import('../components/view/news/View13.vue'),
                    meta: {
                        title: '恒宝股份召开2020年Q1-Q3业绩回顾'
                    }
                },
                {
                    path: '/news/view14',
                    component: () => import('../components/view/news/View14.vue'),
                    meta: {
                        title: '“恒宝邮局”来啦!'
                    }
                },
                {
                    path: '/news/view15',
                    component: () => import('../components/view/news/View15.vue'),
                    meta: {
                        title: 'DIY银行卡新闻'
                    }
                },
                {
                    path: '/news/view16',
                    component: () => import('../components/view/news/View16.vue'),
                    meta: {
                        title: '聚焦创新科技，勇攀科技高峰 ——恒宝股份再次荣获2020年度科技创新“梦溪奖”'
                    }
                },
                {
                    path: '/news/view17',
                    component: () => import('../components/view/news/View17.vue'),
                    meta: {
                        title: '以劳动筑价值，以价值促先进'
                    }
                },
                {
                    path: '/news/view18',
                    component: () => import('../components/view/news/View18.vue'),
                    meta: {
                        title: '热烈庆祝恒宝股份有限公司荣获中国专利优秀奖'
                    }
                },
                {
                    path: '/news/view19',
                    component: () => import('../components/view/news/View19.vue'),
                    meta: {
                        title: '恒宝硬核产品'
                    }
                },
                {
                    path: '/news/view20',
                    component: () => import('../components/view/news/View20.vue'),
                    meta: {
                        title: '热烈祝贺恒宝股份通过GSMA SAS SM湿认证'
                    }
                },
                {
                    path: '/news/view21',
                    component: () => import('../components/view/news/View21.vue'),
                    meta: {
                        title: '坚定理想信念，夯实“四史”宣传'
                    }
                },
                {
                    path: '/news/view22',
                    component: () => import('../components/view/news/View22.vue'),
                    meta: {
                        title: '让初心薪火相传 把使命永担在肩'
                    }
                },
                {
                    path: '/news/view23',
                    component: () => import('../components/view/news/View23.vue'),
                    meta: {
                        title: '不忘初心，砥砺前行'
                    }
                },
                {
                    path: '/news/view24',
                    component: () => import('../components/view/news/View24.vue'),
                    meta: {
                        title: '恒宝股份：为数字人民币应用场景带来“中国方案”'
                    }
                },
                {
                    path: '/news/view25',
                    component: () => import('../components/view/news/View25.vue'),
                    meta: {
                        title: '拥抱变革，分享机遇，共促发展'
                    }
                },
                {
                    path: '/news/view26',
                    component: () => import('../components/view/news/View26.vue'),
                    meta: {
                        title: '恒宝股份数字人民币应用，助力低碳大众化'
                    }
                },
                {
                    path: '/news/view27',
                    component: () => import('../components/view/news/View27.vue'),
                    meta: {
                        title: '再攻一城——热烈庆祝恒宝股份有限公司新产品顺利通过国家金融科技测评中心检测'
                    }
                },
                {
                    path: '/news/view28',
                    component: () => import('../components/view/news/View28.vue'),
                    meta: {
                        title: '热烈庆祝恒宝股份与江苏邮政开启战略合作'
                    }
                },
                {
                    path: '/news/view29',
                    component: () => import('../components/view/news/View29.vue'),
                    meta: {
                        title: '热烈庆祝恒宝股份荣获“金融科技创新奖”-2021.11.4发布'
                    }
                },
                {
                    path: '/news/view30',
                    component: () => import('../components/view/news/View30.vue'),
                    meta: {
                        title: '“恒心”打磨  “恒宝”“恒神”高光闪耀'
                    }
                },
                {
                    path: '/news/view31',
                    component: () => import('../components/view/news/View31.vue'),
                    meta: {
                        title: '热烈庆祝恒宝股份入选2021年江苏省软件企业核心竞争力评价（规模型）企业名单'
                    }
                },
                {
                    path: '/news/view32',
                    component: () => import('../components/view/news/View32.vue'),
                    meta: {
                        title: '深耕数字经济，助力“强富美高”新江苏'
                    }
                },
                {
                    path: '/news/view33',
                    component: () => import('../components/view/news/View33.vue'),
                    meta: {
                        title: '奋进新征程，建功新时代'
                    }
                },
                {
                    path: '/news/view34',
                    component: () => import('../components/view/news/View34.vue'),
                    meta: {
                        title: '热烈庆祝恒宝股份荣获“金松奖”'
                    }
                },
                {
                    path: '/news/view35',
                    component: () => import('../components/view/news/View35.vue'),
                    meta: {
                        title: '低碳让生活更美好'
                    }
                },
                {
                    path: '/news/view36',
                    component: () => import('../components/view/news/View36.vue'),
                    meta: {
                        title: '我持彩练当空舞-恒宝股份斩获多枚全球制卡行业“奥斯卡”奖'
                    }
                },
                {
                    path: '/news/view37',
                    component: () => import('../components/view/news/View37.vue'),
                    meta: {
                        title: '钱京先生当选江苏省工商联（总商会）第十二届执行委员会常务委员、副会长'
                    }
                },
                {
                    path: '/news/view38',
                    component: () => import('../components/view/news/View38.vue'),
                    meta: {
                        title: '恒宝股份荣誉受邀 参展第六届丝绸之路国际博览会'
                    }
                },
                {
                    path: '/news/view39',
                    component: () => import('../components/view/news/View39.vue'),
                    meta: {
                        title: '数字金融大放异彩 谢谢你们的爱'
                    }
                },
                {
                    path: '/news/view40',
                    component: () => import('../components/view/news/View40.vue'),
                    meta: {
                        title: '衣食住行 “碰一碰” 恒宝股份数币钱包融入日常生活'
                    }
                },

                {
                    path: '/news/view41',
                    component: () => import('../components/view/news/View41.vue'),
                    meta: {
                        title: '恒宝公益 | “谢谢你们的爱”'
                    }
                },

                {
                    path: '/news/view42',
                    component: () => import('../components/view/news/View42.vue'),
                    meta: {
                        title: '“又双叒”入选！恒宝股份再度成功入围综合实力评估指数百家企业名单'
                    }
                },

                {
                    path: '/news/view44',
                    component: () => import('../components/view/news/View44.vue'),
                    meta: {
                        title: '恒宝股份党委圆满完成换届选举大会'
                    }
                },
                {
                    path: '/news/view46',
                    component: () => import('../components/view/news/View46.vue'),
                    meta: {
                        title: '开年传捷报！恒宝股份荣获第九届金松奖“最佳金融科技创新奖”'
                    }
                },
                {
                    path: '/news/view47',
                    component: () => import('../components/view/news/View47.vue'),
                    meta: {
                        title: '将雷锋精神落到实处——恒宝股份为广大市民解读数字人民币'
                    }
                },
                {
                    path: '/news/view48',
                    component: () => import('../components/view/news/View48.vue'),
                    meta: {
                        title: '数字人民币新场景闪亮登场 ∣ 恒宝股份助力江苏文旅打造数字旅游新业态'
                    }
                },
                {
                    path: '/news/view49',
                    component: () => import('../components/view/news/View49.vue'),
                    meta: {
                        title: '恒宝股份硬件钱包又添力作，“摩卡”开启无网消费新体验'
                    }
                },
                {
                    path: '/news/view50',
                    component: () => import('../components/view/news/View50.vue'),
                    meta: {
                        title: '全国首创！恒宝股份助力深圳通数字人民币准账户硬钱包落地公共交通领域应用！'
                    }
                },
                {
                    path: '/news/view51',
                    component: () => import('../components/view/news/View51.vue'),
                    meta: {
                        title: '执着创新，闪耀依兰——热烈祝贺恒宝股份23年度斩获多项依兰奖'
                    }
                },
                {
                    path: '/news/view52',
                    component: () => import('../components/view/news/View52.vue'),
                    meta: {
                        title: '聚焦科技创新，助力数字经济——热烈欢迎省工商联领导一行莅临指导'
                    }
                },
                {
                    path: '/news/view53',
                    component: () => import('../components/view/news/View53.vue'),
                    meta: {
                        title: '重磅！恒宝股份助力全国首款账户模式数字人民币硬钱包亮相亚运驿站'
                    }
                },
                {
                    path: '/news/view55',
                    component: () => import('../components/view/news/View55.vue'),
                    meta: {
                        title: '又一首发！恒宝股份助力长沙首款乡村主题数字人民币硬钱包成功落地'
                    }
                },
                {
                    path: '/news/view57',
                    component: () => import('../components/view/news/View57.vue'),
                    meta: {
                        title: '踏寻红色足迹、传承革命精神、聚力恒宝发展——记建党102周年恒宝党委“七一”活动'
                    }
                },
                {
                    path: '/news/view58',
                    component: () => import('../components/view/news/View58.vue'),
                    meta: {
                        title: '立足数字化，创造文旅新体验——恒宝股份助力江苏首个旅游景区数字人民币应用体验区落地'
                    }
                },
                {
                    path: '/news/view59',
                    component: () => import('../components/view/news/View59.vue'),
                    meta: {
                        title: '全国首创！恒宝股份助力首张智能车联网数字人民币主题硬钱包面世'
                    }
                },
                {
                    path: '/news/view61',
                    component: () => import('../components/view/news/View61.vue'),
                    meta: {
                        title: '解锁新功能！恒宝股份助力数字人民币上线SIM卡硬钱包'
                    }
                },
                {
                    path: '/news/view62',
                    component: () => import('../components/view/news/View62.vue'),
                    meta: {
                        title: '全国首次！恒宝股份助力工行成功实现在国际赛事规模化发行数字人民币硬钱包'
                    }
                },
                {
                    path: '/news/view63',
                    component: () => import('../components/view/news/View63.vue'),
                    meta: {
                        title: '传递信任 服务发展！热烈祝贺恒宝股份荣获移动金融TEE安全创新应用示范机构证书'
                    }
                },
                {
                    path: '/news/view64',
                    component: () => import('../components/view/news/View64.vue'),
                    meta: {
                        title: '火爆出圈！恒宝股份数字人民币产品亮相服贸会热门打卡点'
                    }
                },
                {
                    path: '/news/view65',
                    component: () => import('../components/view/news/View65.vue'),
                    meta: {
                        title: '恒宝公益∣恒宝股份爱心捐赠，践行社会责任、彰显企业使命'
                    }
                },
                {
                    path: '/news/view66',
                    component: () => import('../components/view/news/View66.vue'),
                    meta: {
                        title: '跨界融合，双向赋能！恒宝助力打造数字人民币新体验'
                    }
                },
                {
                    path: '/news/view67',
                    component: () => import('../components/view/news/View67.vue'),
                    meta: {
                        title: '添彩亚运！恒宝股份“智造”出圈数币产品！'
                    }
                },
                {
                    path: '/news/view68',
                    component: () => import('../components/view/news/View68.vue'),
                    meta: {
                        title: '亚运团宠，恒宝数字人民币手环硬钱包荣登央视报道'
                    }
                },
                {
                    path: '/news/view69',
                    component: () => import('../components/view/news/View69.vue'),
                    meta: {
                        title: '官宣！恒宝股份首批签约入驻深圳罗湖数字人民币应用生态示范区'
                    }
                },
                {
                    path: '/news/view70',
                    component: () => import('../components/view/news/View70.vue'),
                    meta: {
                        title: '官宣！恒宝股份首批签约入驻深圳罗湖数字人民币应用生态示范区'
                    }
                },                {
                    path: '/news/view71',
                    component: () => import('../components/view/news/View71.vue'),
                    meta: {
                        title: '官宣！恒宝股份首批签约入驻深圳罗湖数字人民币应用生态示范区'
                    }
                },                {
                    path: '/news/view72',
                    component: () => import('../components/view/news/View72.vue'),
                    meta: {
                        title: '官宣！恒宝股份首批签约入驻深圳罗湖数字人民币应用生态示范区'
                    }
                },                {
                    path: '/news/view73',
                    component: () => import('../components/view/news/View73.vue'),
                    meta: {
                        title: '官宣！恒宝股份首批签约入驻深圳罗湖数字人民币应用生态示范区'
                    }
                }, {
                    path: '/news/view75',
                    component: () => import('../components/view/news/View75.vue'),
                    meta: {
                        title: '恒宝股份赋能智慧交通新场景——江苏省内首个支持数字人民币软硬钱包支付的公交场景正式上线'
                    }
                },    
                {
                    path: '/news/view76',
                    component: () => import('../components/view/news/View76.vue'),
                    meta: {
                        title: '恒宝股份助力中国工商银行在“明水古城”正式发布数字人民币硬钱包'
                    }
                },    
                {
                    path: '/news/view77',
                    component: () => import('../components/view/news/View77.vue'),
                    meta: {
                        title: '聚焦数字人民币产业可持续发展，不断提升企业“成长力”'
                    }
                },     
                {
                    path: '/news/view78',
                    component: () => import('../components/view/news/View78.vue'),
                    meta: {
                        title: '恒宝股份亮相迪拜2024 Seamless 展会'
                    }
                },     
                {
                    path: '/news/view79',
                    component: () => import('../components/view/news/View79.vue'),
                    meta: {
                        title: '行迈自迩，踔厉奋发，恒宝再获2024ICMA依兰奖四大奖项，匠心独具闪耀全球！'
                    }
                },         

                {
                    path: '/contract/index',
                    component: () => import('../components/view/contract/Index.vue'),
                    meta: {
                        title: '联系我们'
                    }
                },
                {
                    path: '/contract',
                    component: () => import('../components/view/contract/Index.vue'),
                    meta: {
                        title: '联系我们'
                    }
                },
                {
                    path: '/legal',
                    component: () => import('../components/view/legal/Index.vue'),
                    meta: {
                        title: '法律声明'
                    }
                },
                {
                    path: '/privacy',
                    component: () => import('../components/view/privacy/Index.vue'),
                    meta: {
                        title: '隐私政策'
                    }
                },



                // c产品相关


                {
                    path: '/product',
                    component: () => import('../components/view/product/Index.vue'),
                    meta: {
                        title: '产品'
                    }
                },

                {
                    path: '/product/pay',
                    component: () => import('../components/view/product/Pay.vue'),
                    meta: {
                        title: '卡片支付与安全'
                    }
                },
                {
                    path: '/product/financial',
                    component: () => import('../components/view/product/Financial.vue'),
                    meta: {
                        title: '数字化金融'
                    }
                },
                {
                    path: '/product/financialview/view1',
                    component: () => import('../components/view/product/financialview/View1.vue'),
                    meta: {
                        title: '区块链金融'
                    }
                },
                {
                    path: '/product/financialview/view2',
                    component: () => import('../components/view/product/financialview/View2.vue'),
                    meta: {
                        title: '数字资产钱包'
                    }
                },
                {
                    path: '/product/financialview/view3',
                    component: () => import('../components/view/product/financialview/View3.vue'),
                    meta: {
                        title: '供应链金融'
                    }
                },
                {
                    path: '/product/identity',
                    component: () => import('../components/view/product/Identity.vue'),
                    meta: {
                        title: '身份认证'
                    }
                },

                {
                    path: '/product/identityview/view1',
                    component: () => import('../components/view/product/identityview/View1.vue'),
                    meta: {
                        title: '智能密码钥匙'
                    }
                },
                {
                    path: '/product/identityview/view2',
                    component: () => import('../components/view/product/identityview/View2.vue'),
                    meta: {
                        title: '移动智能终端手机盾 '
                    }
                },
                {
                    path: '/product/identityview/view3',
                    component: () => import('../components/view/product/identityview/View3.vue'),
                    meta: {
                        title: '税务安全产品'
                    }
                },
                {
                    path: '/product/online',
                    component: () => import('../components/view/product/Online.vue'),
                    meta: {
                        title: '移动通信与物联网'
                    }
                },
                {
                    path: '/product/safe',
                    component: () => import('../components/view/product/Safe.vue'),
                    meta: {
                        title: '安全智能终端'
                    }
                },


                {
                    path: '/product/safeview/view1',
                    component: () => import('../components/view/product/safeview/View1.vue'),
                    meta: {
                        title: '蓝牙型安全读写终端'
                    }
                },
                {
                    path: '/product/safeview/view2',
                    component: () => import('../components/view/product/safeview/View2.vue'),
                    meta: {
                        title: 'mPOS'
                    }
                },
                {
                    path: '/product/safeview/view3',
                    component: () => import('../components/view/product/safeview/View3.vue'),
                    meta: {
                        title: '手机POS'
                    }
                },
                {
                    path: '/product/safeview/view4',
                    component: () => import('../components/view/product/safeview/View4.vue'),
                    meta: {
                        title: '刷脸支付终端'
                    }
                },

                {
                    path: '/product/system',
                    component: () => import('../components/view/product/System.vue'),
                    meta: {
                        title: '系统平台'
                    }
                },

                {
                    path: '/product/systemview/view1',
                    component: () => import('../components/view/product/systemview/View1.vue'),
                    meta: {
                        title: '一卡通云平台'
                    }
                },
                {
                    path: '/product/systemview/view2',
                    component: () => import('../components/view/product/systemview/View2.vue'),
                    meta: {
                        title: '移动支付平台'
                    }
                },

                {
                    path: '/product/onlineview/esim',
                    component: () => import('../components/view/product/onlineview/Esim.vue'),
                    meta: {
                        title: 'eSIM智能卡'
                    }
                },

                {
                    path: '/product/onlineview/sim',
                    component: () => import('../components/view/product/onlineview/Sim.vue'),
                    meta: {
                        title: 'SIM卡'
                    }
                },

                {
                    path: '/product/onlineview/esim',
                    component: () => import('../components/view/product/onlineview/Esim.vue'),
                    meta: {
                        title: 'eSIM智能卡'
                    }
                },
                {
                    path: '/product/onlineview/m2m',
                    component: () => import('../components/view/product/onlineview/M2m.vue'),
                    meta: {
                        title: 'M2M智能卡'
                    }
                },

                {
                    path: '/cardview/IC',
                    component: () => import('../components/view/cardview/IC.vue'),
                    meta: {
                        title: '银行IC卡'
                    }
                },
                {
                    path: '/cardview/ETC',
                    component: () => import('../components/view/cardview/ETC.vue'),
                    meta: {
                        title: 'ETC卡'
                    }
                },
                {
                    path: '/cardview/city',
                    component: () => import('../components/view/cardview/City.vue'),
                    meta: {
                        title: '城市一卡通'
                    }
                },
                {
                    path: '/cardview/social',
                    component: () => import('../components/view/cardview/Social.vue'),
                    meta: {
                        title: '社保卡'
                    }
                },
                {
                    path: '/cardview/CAPPD',
                    component: () => import('../components/view/cardview/CAPPD.vue'),
                    meta: {
                        title: '智慧残联'
                    }
                },
                {
                    path: '/cardview/road',
                    component: () => import('../components/view/cardview/Road.vue'),
                    meta: {
                        title: '道路运输证'
                    }
                },

                {
                    path: '/cardview/card',
                    component: () => import('../components/view/cardview/Card.vue'),
                    meta: {
                        title: '电子证照'
                    }
                },

                {
                    path: '/cardview/newcard',
                    component: () => import('../components/view/cardview/Newcard.vue'),
                    meta: {
                        title: '社保卡'
                    }
                },

                // 行业解决方案


                {
                    path: '/solution/test',
                    component: () => import('../components/view/solution/test/Index.vue'),
                    meta: {
                        title: '行业解决方案'
                    }
                },

                {
                    path: '/solution/card',
                    component: () => import('../components/view/solution/Card.vue'),
                    meta: {
                        title: '移动支付云平台'
                    }
                },


                {
                    path: '/solution/cardview/view1',
                    component: () => import('../components/view/solution/cardview/View1.vue'),
                    meta: {
                        title: '高校校园一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view2',
                    component: () => import('../components/view/solution/cardview/View2.vue'),
                    meta: {
                        title: '园区一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view3',
                    component: () => import('../components/view/solution/cardview/View3.vue'),
                    meta: {
                        title: '企事业一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view4',
                    component: () => import('../components/view/solution/cardview/View4.vue'),
                    meta: {
                        title: '社区一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view5',
                    component: () => import('../components/view/solution/cardview/View5.vue'),
                    meta: {
                        title: '景区一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view6',
                    component: () => import('../components/view/solution/cardview/View6.vue'),
                    meta: {
                        title: '商圈一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view7',
                    component: () => import('../components/view/solution/cardview/View7.vue'),
                    meta: {
                        title: '市场一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view8',
                    component: () => import('../components/view/solution/cardview/View8.vue'),
                    meta: {
                        title: '监狱戒所一卡通解决方案'
                    }
                },
                {
                    path: '/solution/cardview/view9',
                    component: () => import('../components/view/solution/cardview/View9.vue'),
                    meta: {
                        title: '银行托管解决方案'
                    }
                },

                {
                    path: '/solution/financial',
                    component: () => import('../components/view/solution/Financial.vue'),
                    meta: {
                        title: '金融行业解决方案'
                    }
                },


                {
                    path: '/solution/financialview/view1',
                    component: () => import('../components/view/solution/financialview/View1.vue'),
                    meta: {
                        title: 'DIY个性化制卡整体解决方案'
                    }
                },
                {
                    path: '/solution/financialview/view2',
                    component: () => import('../components/view/solution/financialview/View2.vue'),
                    meta: {
                        title: '即时制卡发卡解决方案'
                    }
                },
                {
                    path: '/solution/financialview/view3',
                    component: () => import('../components/view/solution/financialview/View3.vue'),
                    meta: {
                        title: '金融IC卡订单管理解决方案'
                    }
                },

                {
                    path: '/solution/financialview/view4',
                    component: () => import('../components/view/solution/financialview/View4.vue'),
                    meta: {
                        title: '金融IC卡即时发卡系统'
                    }
                },



                {
                    path: '/solution/material',
                    component: () => import('../components/view/solution/Material.vue'),
                    meta: {
                        title: '复合材料解决方案'
                    }
                },

                {
                    path: '/solution/materialview/view1',
                    component: () => import('../components/view/solution/materialview/View1.vue'),
                    meta: {
                        title: '复合材料行业生产应用'
                    }
                },
                {
                    path: '/solution/car',
                    component: () => import('../components/view/solution/Car.vue'),
                    meta: {
                        title: '汽车行业解决方案'
                    }
                },

                {
                    path: '/solution/online',
                    component: () => import('../components/view/solution/Online.vue'),
                    meta: {
                        title: '通信行业解决方案'
                    }
                },

                {
                    path: '/solution/online',
                    component: () => import('../components/view/solution/Online.vue'),
                    meta: {
                        title: '通信行业解决方案'
                    }
                },
                {
                    path: '/solution/onlineview/view1',
                    component: () => import('../components/view/solution/onlineview/View1.vue'),
                    meta: {
                        title: '物联网安全解决方案'
                    }
                },
                {
                    path: '/solution/onlineview/view2',
                    component: () => import('../components/view/solution/onlineview/View2.vue'),
                    meta: {
                        title: '物联网链接解决方案'
                    }
                },
                {
                    path: '/solution/onlineview/view3',
                    component: () => import('../components/view/solution/onlineview/View3.vue'),
                    meta: {
                        title: 'eSIM解决方案'
                    }
                },




                {
                    path: '/card',
                    component: () => import('../components/view/card/Index.vue'),
                    meta: {
                        title: '卡片支付与安全'
                    }
                },

                {
                    path: '/join/index',
                    component: () => import('../components/view/join/Index.vue'),
                    meta: {
                        title: recruitTitle
                    }
                },
                {
                    path: '/join/detail',
                    component: () => import('../components/view/join/jobDetail.vue'),
                    meta: {
                        title: '在线招聘'
                    }
                },
                {
                    path: '/join/recruitment',
                    component: () => import('../components/view/join/Recruitment.vue'),
                    meta: {
                        title: '毕业生招聘'
                    }
                },

                {
                    path: '/join/add',
                    component: () => import('../components/view/join/Add.vue'),
                    meta: {
                        title: '在线申请'
                    }
                },

                {
                    path: '/join/about',
                    component: () => import('../components/view/join/About.vue'),
                    meta: {
                        title: '发现恒宝'
                    }
                },
                {
                    path: '/join/joinview/hengbao',
                    component: () => import('../components/view/join/joinview/Hengbao.vue'),
                    meta: {
                        title: '工作环境'
                    }
                },

                {
                    path: '/join/joinview/promotion',
                    component: () => import('../components/view/join/joinview/Promotion.vue'),
                    meta: {
                        title: '职业晋升'
                    }
                },


                {
                    path: '/development/index',
                    component: () => import('../components/view/development/Index.vue'),
                    meta: {
                        title: '创新'
                    }
                },

                {
                    path: '/development/compliance',
                    component: () => import('../components/view/development/Compliance.vue'),
                    meta: {
                        title: '合规'
                    }
                }
            ]
        },
        // {
        //     path: '*',
        //     redirect: '/404'
        // },
        // {
        //     path: '/404',
        //     component: () => import('../components/404.vue'),
        //     meta: {
        //         title: '404'
        //     },
        // },
        {
            path: '/header',
            component: () => import('../components/view/public/Header.vue'),
            meta: {
                title: 'header'
            },
        },
        // {
        //     path: '/mobile',
        //     component: () => import('../components/view/public/Moblie.vue'),
        //     meta: {
        //         title: 'header'
        //     },
        // },
        {
            path: '/floot',
            component: () => import('../components/view/public/Flooter.vue'),
            meta: {
                title: 'floot'
            },
        }, {
            path: '/news',
            component: () => import('../components/view/public/News.vue'),
            meta: {
                title: 'news'
            },
        },
        {
            path: '/download',
            component: () => import('../components/view/public/Down.vue'),
            meta: {
                title: 'download'
            },
        }

    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
         return savedPosition
        } else {
         return { x: 0, y: 0 }
        }
    }
});